import theme from "app/Theme/Theme";
import React from "react";
import Svg, { Path } from "react-native-svg";

const ResourcesIcon = ({ width, height, color }) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 21 23"
      preserveAspectRatio="xMidYMin meet"
    >
      <Path
        d="M19.326 7.454a.385.385 0 0 0-.393-.054l-6.243 2.703a2.458 2.458 0 0 1-.96.175 3.5 3.5 0 0 1-1.34-.265 1.634 1.634 0 0 1-.305-.168c.026-.013.059-.027.094-.042l5.678-2.458.847.362V6.649a.5.5 0 0 0-.183-.396.382.382 0 0 0-.391-.053L9.887 8.903a1.45 1.45 0 0 0-.498.312.858.858 0 0 0-.255.604l.002.017v9.52l-.001.013.002.006v.01h.001c.013.333.18.545.341.695.504.445 1.35.694 2.252.707.426 0 .86-.065 1.26-.237l6.245-2.704a.479.479 0 0 0 .273-.447v-9.55a.507.507 0 0 0-.183-.395Zm-3.96-1.81a.5.5 0 0 0-.175-.36.385.385 0 0 0-.392-.053L8.556 7.933a2.473 2.473 0 0 1-.96.175 3.5 3.5 0 0 1-1.341-.267 1.582 1.582 0 0 1-.304-.166c.026-.013.058-.028.094-.042l5.679-2.458.846.362V4.48a.5.5 0 0 0-.183-.395.384.384 0 0 0-.392-.054L5.752 6.735a1.446 1.446 0 0 0-.497.312.858.858 0 0 0-.255.604l.002.018v9.55h.001c.013.332.181.544.341.694.505.445 1.351.693 2.253.706.244-.002.489-.028.728-.079V9.836a1.653 1.653 0 0 1 .492-1.2c.22-.213.482-.38.77-.488l5.779-2.504Z"
        fill={color}
      />
    </Svg>
  );
};

ResourcesIcon.defaultProps = {
  width: 21,
  height: 23,
  color: theme.colors["neutral.350"],
};

export default ResourcesIcon;
